import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';
import { api } from '../../services/api';
import { useAuthStore } from '../../store/authStore';
import { israelHhmm } from '../../utils/israelTime';

/**
 * FIX-CLAUDE-B (D-314 §8, option A; stage A C6) — the progress notes Claude
 * kept on HER open log, shown only to her, inside that log (the "מה בוצע"
 * window), as the base for what she writes. They are deleted by the server
 * once "מה בוצע" is saved. Nothing is shown when there are none.
 */
export default function ClaudeProgressNotes({ workRecordId }: { workRecordId?: string | null }) {
  const { t } = useTranslation();
  const isEmployee = useAuthStore((s) => s.user?.is_ote_employee === true);
  const q = useQuery({
    queryKey: ['claude-progress-notes', workRecordId],
    queryFn: () => api.getClaudeProgressNotes(workRecordId as string),
    enabled: isEmployee && !!workRecordId,
    staleTime: 15_000,
  });
  const notes = q.data?.data ?? [];
  if (notes.length === 0) return null;
  return (
    <section className="rounded-lg border border-surface-200 bg-surface-50 px-3 py-2" aria-label={t('claudeConnect.notesTitle')}>
      <p className="flex items-center gap-1.5 text-xs font-semibold text-surface-800">
        <Sparkles size={12} aria-hidden="true" />
        {t('claudeConnect.notesTitle')}
        <span className="font-normal text-surface-600">· {t('claudeConnect.notesOnlyYou')}</span>
      </p>
      <ul className="mt-1 space-y-0.5 text-xs text-surface-700">
        {notes.map((n) => (
          <li key={n.id} className="flex gap-2">
            <span className="tabular-nums text-surface-600 shrink-0">{israelHhmm(n.created_at)}</span>
            <span className="min-w-0 break-words" dir="auto">{n.note}</span>
          </li>
        ))}
      </ul>
    </section>
  );
}
